import { HeadCellType } from '../../utils/appConstants';

export const priceTableHeadCells: HeadCellType[] = [
  {
    id: 'up',
    align: 'left',
    disablePadding: false,
    sortEnabled: false,
    label: '',
    width: '1%',
  },
  {
    id: 'description',
    align: 'left',
    disablePadding: false,
    sortEnabled: false,
    label: 'Item Description',
    width: '19%',
  },
  {
    id: 'location',
    align: 'center',
    disablePadding: false,
    sortEnabled: false,
    label: 'Location',
    width: '25%',
  },
  {
    id: 'company',
    align: 'center',
    disablePadding: false,
    sortEnabled: false,
    label: 'Company',
    width: '15%',
  },
  {
    id: 'term',
    align: 'center',
    disablePadding: false,
    sortEnabled: false,
    label: 'Term',
    width: '15%',
  },
  {
    id: 'dates',
    align: 'center',
    disablePadding: false,
    sortEnabled: false,
    label: 'Service Date(s)',
    width: '10%',
  },
  {
    id: 'total',
    align: 'right',
    disablePadding: false,
    sortEnabled: false,
    label: 'Total',
    width: '10%',
  },
];
//   {
//     id: 'up',
//     align: 'left',
//     disablePadding: false,
//     sortEnabled: false,
//     label: '',
//     width: '1%',
//   },
//   {
//     id: 'description',
//     align: 'left',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Item Description',
//     width: '19%',
//   },
//   {
//     id: 'location',
//     align: 'center',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Location',
//     width: '25%',
//   },
//   {
//     id: 'provider',
//     align: 'center',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Provider',
//     width: '15%',
//   },
//   {
//     id: 'term',
//     align: 'center',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Term',
//     width: '15%',
//   },
//   {
//     id: 'dates',
//     align: 'center',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Service Date(s)',
//     width: '10%',
//   },
//   {
//     id: 'total',
//     align: 'right',
//     disablePadding: false,
//     sortEnabled: false,
//     label: 'Total',
//     width: '10%',
//   },
// ];

export type csvHeaderType = { label: string, key: string }[];
export const csvIncomeHeaders: csvHeaderType = [
  { label: 'Reference ID', key: 'id' },
  { label: 'Resource ID', key: 'resourceId' },
  { label: 'Description', key: 'description' },
  { label: 'Location', key: 'location' },
  { label: 'Customer', key: 'provider' },
  { label: 'Service', key: 'service' },
  { label: 'Price', key: 'price' },
  { label: 'Term', key: 'term' },
  { label: 'Quantity', key: 'quantity' },
  { label: '$/month', key: 'perMonth' },
  { label: 'Service Start Date', key: 'startDate' },
  { label: 'Service End Date', key: 'endDate' },
  { label: 'Filter Start Date', key: 'filterStartDate' },
  { label: 'Filter End Date', key: 'filterEndDate' },
  { label: 'Total', key: 'total' },
];
export const csvExpenseHeaders: csvHeaderType = [
  { label: 'Reference ID', key: 'id' },
  { label: 'Resource ID', key: 'resourceId' },
  { label: 'Description', key: 'description' },
  { label: 'Location', key: 'location' },
  { label: 'Provider', key: 'provider' },
  { label: 'Service', key: 'service' },
  { label: 'Price', key: 'price' },
  { label: 'Term', key: 'term' },
  { label: 'Quantity', key: 'quantity' },
  { label: '$/month', key: 'perMonth' },
  { label: 'Service Start Date', key: 'startDate' },
  { label: 'Service End Date', key: 'endDate' },
  { label: 'Filter Start Date', key: 'filterStartDate' },
  { label: 'Filter End Date', key: 'filterEndDate' },
  { label: 'Total', key: 'total' },
];
